import AddRoundedIcon from "@mui/icons-material/AddRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import { Button, Stack } from "@mui/material";
import ActionsMenuButton from "@entrilia/shared/components/ActionsMenuButton";
import AuthorizedBox from "@entrilia/shared/components/AuthorizedBox";

interface Props {
  onNewRun: () => void;
  onDelete: () => void;
}

const WorkbookTemplatesGidActionCell = ({ onNewRun, onDelete }: Props) => {
  return (
    <AuthorizedBox permissions={["ManageReports"]}>
      <Stack direction="row" spacing={0.5} sx={{ alignItems: "center" }}>
        <Button
          color="primary"
          onClick={(e) => {
            e.stopPropagation();
            onNewRun();
          }}
          startIcon={<AddRoundedIcon />}
        >
          New Run
        </Button>
        <ActionsMenuButton
          items={[{ label: "Delete", icon: <DeleteOutlineRoundedIcon color="error" />, onClick: onDelete }]}
        />
      </Stack>
    </AuthorizedBox>
  );
};

export default WorkbookTemplatesGidActionCell;
